module.exports = __webpack_public_path__ + "img/hr.cc944d35.svg";